/**
 * 英文错误码配置
 */

import common from "./common.json";
import uranus from "./uranus.json";
import earth from "./earth.json";
import mercury from "./mercury.json";
import moon from "./moon.json";
import admin from "./admin.json";
import ep from "./ep.json";
const config = {
    // 未知错误
    E00000: (context, response) => {
        context?.message?.error(response.message || "system error...");
    },
    // 版本不一致
    E00016: (context, response) => {
        context?.reloadAlert();
    },
    // 鉴权失败
    E00005: (context) => {
        context?.message?.error("please login");
        context?.redirectToLogin();
    },
    ...earth,
    ...uranus,
    ...mercury,
    ...moon,
    ...admin,
    ...common,
    ...ep,
};
export default config;
